import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { checkCurrentUser } from '../../redux/auth/authSlice';
import { RootState, AppDispatch } from '../../redux';

export const useAuth = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { user, loading, error } = useSelector((state: RootState) => state.auth);
    
    useEffect(() => {
      // Track if the effect has run
      let mounted = true;
      
      // Only fetch if we don't have a user and not already loading
      if (!user && !loading && mounted) {
        dispatch(checkCurrentUser());
      }
      
      // Cleanup function to prevent further dispatches if component unmounts
      return () => {
        mounted = false;
      };
    }, [dispatch]); // Remove user and loading from dependencies
    
    return {
      user,
      isLoading: loading,
      isAuthenticated: !!user,
      error
    };
 };